// extracted by mini-css-extract-plugin
export default {"root":"footer_root__1jT5x py-[3rem] bg-[#142B51] text-[#96A0BA]","link":"footer_link__J5xRo text-base text-[#96A0BA]","logo":"footer_logo__mgPDz mb-[48px]"};